import { Controller } from "@hotwired/stimulus"
import { useStore } from "stimulus-store"
import { allRoomsStore } from "../../stores/locales/all_rooms_store"

// Connects to data-controller="print-mapper--room-badge"
export default class extends Controller {

    static stores = [allRoomsStore]
    static targets = ["badge"]
    static values = { roomId: String }

    connect() {
        useStore(this)
        this.updateBadge(this.allRoomsStoreValue)
    }

    // Auto-called by stimulus-store when allRoomsStore changes
    onAllRoomsStoreUpdate(rooms) {
        this.updateBadge(rooms)
    }

    updateBadge(rooms) {
        if (!this.hasRoomIdValue || !this.roomIdValue) {
            this.hideBadge()
            return
        }

        if (!Array.isArray(rooms) || rooms.length === 0) {
            this.hideBadge()
            return
        }

        // Find this workstation's room in the loaded rooms
        const room = rooms.find(r => r.id === this.roomIdValue)
        if (room) {
            this.showBadge(room.name)
        } else {
            this.hideBadge()
        }
    }

    showBadge(name) {
        if (this.hasBadgeTarget) {
            this.badgeTarget.textContent = name
            this.badgeTarget.classList.remove('d-none')
        }
    }

    hideBadge() {
        if (this.hasBadgeTarget) {
            this.badgeTarget.classList.add('d-none')
        }
    }
}
